import { Card, CardContent, Box, Skeleton } from "@mui/material";
import React, { Suspense } from "react";
import { NotificationCard } from "@/Pages/Dashboard/dashboardConfig";
import { useDispatch, useSelector } from "react-redux";
import { lazyWithRetry as lazy } from "@/utils/lazyWithRetry";
import { markAsReadAlerts } from "@/store/alerts/alertsAction";
import { Header } from "../Carousel";

// The /notifications page, reused as this card's body. A static import from
// here kept that page in the entry chunk — the dashboard is not split, so
// Rollup reported the route-level and header-level lazy() for the same module
// as INEFFECTIVE_DYNAMIC_IMPORT and left it where it was.
const NotificationsBody = lazy(() => import("@/Pages/Notifications"));

const Notifications = ({ t }) => {
  const { alerts, loading, userId } = useSelector(
    (state) => state.alertsReducer
  );
  const dispatch = useDispatch();
  return (
    <Box
      sx={{
        width: `${NotificationCard.width}px`,
        float: "right",
        ml: 4,
      }}
    >
      <Header
        title={t("Notifications")}
        actionText={t("MarkAsRead")}
        onClickAction={() => {
          dispatch(markAsReadAlerts(userId));
        }}
      />
      {loading && alerts.length === 0 ? (
        <Skeleton
          animation="wave"
          variant="rectangular"
          height={NotificationCard.height}
          width={NotificationCard.width}
        />
      ) : (
        <Card
          sx={{
            height: `${NotificationCard.height}px`,
            overflowY: "auto",
            borderTop: (theme) => `4px solid ${theme.palette.primary.main}`,
            "&::-webkit-scrollbar": {
              width: "5px",
              "&-track": {
                background: "transparent",
              },
              "&-thumb": {
                background: (theme) => theme.palette.grey["600"],
                "&:hover": {
                  background: (theme) => theme.palette.grey["600"],
                },
              },
            },
          }}
          id="scrollable-dashboard-notifications-card"
          raised
        >
          <CardContent
            sx={{
              p: (theme) => theme.spacing(0),
              ":last-child": {
                p: 0,
              },
            }}
          >
            <Box>
              <Suspense
                fallback={
                  <Skeleton
                    animation="wave"
                    variant="rectangular"
                    height={NotificationCard.height}
                    width={NotificationCard.width}
                  />
                }
              >
                <NotificationsBody variant="dashboard" />
              </Suspense>
            </Box>
          </CardContent>
        </Card>
      )}
    </Box>
  );
};

export default Notifications;
